import React, { useEffect, useState } from "react";
import {
  InputField,
  RadioGroupField,
  AutocompleteField,
  AsyncAutocomplete,
} from "../../../../components/FormFields";
import { useStateAuthValue } from "../../../../context/Auth/AuthState";
import { useFormikContext } from "formik";
import { generic_data_check_box } from "../../../../constants/constants";
import {
  GetPreexistingDisease,
  GetSurgerys,
} from "../../../../services/userService";
import { getMedicationSearch } from "../../../../services/medicationService";
import { FilesUploadField } from "../../../../components/files-upload-file";

const PetMedicalHistoryForm = ({ formModel }) => {
  const [{ userToken }] = useStateAuthValue();
  const { values, setFieldValue, touched, submitCount } = useFormikContext();
  const [surgeriesList, setSurgeriesList] = useState([]);
  const [frequentMedicationList, setFrequentMedicationList] = useState([]);
  const [preexistingDiseaseList, setPreexistingDiseaseList] = useState([]);
  const {
    allergies,
    allergies_check_box,
    frequent_medication_check_box,
    frequent_medication,
    pre_existing_disease,
    surgeries,
  } = formModel;

  const getPreexistingDisease = async () => {
    try {
      const res = await GetPreexistingDisease(userToken);
      setPreexistingDiseaseList(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      setPreexistingDiseaseList([]);
    }
  };

  const GetSurgeries = async () => {
    try {
      const res = await GetSurgerys(userToken);
      setSurgeriesList(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      setSurgeriesList([]);
    }
  };

  const searchFrequentMedications = async (query) => {
    setFrequentMedicationList([]);
    if (query && query.length > 2) {
      const res = await getMedicationSearch({ description: query }, userToken);
      setFrequentMedicationList(res);
    }
  };

  useEffect(() => {
    if (userToken) {
      getPreexistingDisease();
      GetSurgeries();
    }
  }, [userToken]);

  return (
    <>
      <div className="pet-medical-history-container">
        <div>
          <AutocompleteField
            name={pre_existing_disease.name}
            label={pre_existing_disease.label}
            options={preexistingDiseaseList || []}
            className="field"
            placeholder={pre_existing_disease.placeholder}
          />

          <div>
            <RadioGroupField
              name={allergies_check_box.name}
              label={allergies_check_box.label}
              data={generic_data_check_box}
              className="field field--radio"
              disabled={false}
            />
            <InputField
              name={allergies.name}
              label={allergies.label}
              type="text"
              className="field"
              disabled={values.allergies_check_box == "false"}
            />
          </div>
        </div>
        <div>
          <FilesUploadField
            label="Adjuntar Libreta Sanitaria"
            name="healthBooklet"
            setValues={setFieldValue}
          />

          <FilesUploadField
            label="Adjuntar Estudios Médicos"
            name="medicalStudies"
            setValues={setFieldValue}
          />
        </div>

        <div>
          <AutocompleteField
            name={surgeries.name}
            label={surgeries.label}
            options={surgeriesList || []}
            className="field"
            placeholder={surgeries.placeholder}
            isError={
              (!values[surgeries.name] ||
                values[surgeries.name].length === 0) &&
              (touched[surgeries.name] || submitCount > 0)
            }
          />
          <div>
            <RadioGroupField
              name={frequent_medication_check_box.name}
              label={frequent_medication_check_box.label}
              data={generic_data_check_box}
              className="field field--radio"
              disabled={false}
            />
            <AsyncAutocomplete
              className="field"
              disabled={values[frequent_medication_check_box.name] == "false"}
              name={frequent_medication.name}
              placeholder={frequent_medication.placeholder}
              options={frequentMedicationList}
              selected={values.frequent_medication}
              label={frequent_medication.label}
              searchTextLabel={frequent_medication.searchTextLabel}
              searchTextMinRequired={frequent_medication.searchTextMinRequired}
              requestMethod={(textSearch) =>
                searchFrequentMedications(textSearch)
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PetMedicalHistoryForm;
